/* eslint-disable array-callback-return */
/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { Component } from "react";
import { Select, Spin, Empty } from "antd";
import networkList from "../../../constants/networkList";
import postService from "../../../services/httpService";
import Storage from "../../../services/local-store";
import { OPTION_IDS } from "../../../constants/app-constants";
import { isArray } from "jquery";
import { UserOutlined } from '@ant-design/icons';
class Select2 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      date: new Date(),
      select2options: [],
      loading: false,
      selectdata: {},
      fetching: true,
      mani: null,
    };
  }
  componentDidMount() {
    this.setState((state) => ({ selectdata: this.props.selectdata }));
  }

  componentDidUpdate(prevProps, pervState) {
    if (prevProps.selectdata.value != this.props.selectdata.value) {
      this.setState((state) => ({ selectdata: this.props.selectdata }));
    }
  }

  handleChange(value) {
    console.log(`selected ${value}`);
  }

  onChange(value) {
    // console.clear();
    let selectdata = this.state.selectdata;
    selectdata["value"] = value;

    // this.selectFetchCall();
    let text = null;

    // console.log(this.state.select2options);

    this.state.select2options.map((data, key) => {
      if (data["id"] === value) {
        text = data["name"] || data["value"];
      }
    });

    selectdata["text"] = text;

    // console.log(selectdata);
    this.setState((state) => ({ selectdata: selectdata }));
    if (this.props.selectdata.name === "service") {
      this.state.select2options.map((data, key) => {
        if (data.id === value) {
          this.props.onselectChanges({
            id: this.props.selectdata.name,
            name: this.props.selectdata.name,
            value: value,
            parrentMode: this.props.selectdata.parrentMode,
            parrentName: this.props.selectdata.parrentName,
            serviceTime: data.service_time,
            text: text,
          });
        }
      });
    } else if (
      this.props.selectdata.name === "room_opted" ||
      this.props.selectdata.name === "room_upgrade"
    ) {
     if (value) {
        this.state.select2options.map((data, key) => {
          if (data.id === value) {
            this.props.onselectChanges({
              id: this.props.selectdata.name,
              name: this.props.selectdata.name,
              value: value,
              parrentMode: this.props.selectdata.parrentMode,
              parrentName: this.props.selectdata.parrentName,
              amount: data.amount,
              package_id: data.package_id ? data.package_id : null,
              text: text,
            });
          }
        });
      } else {
        this.props.onselectChanges({
          id: this.props.selectdata.name,
          name: this.props.selectdata.name,
          value: null,
          parrentMode: this.props.selectdata.parrentMode,
          parrentName: this.props.selectdata.parrentName,
          amount: 0,
          package_id: null,
          text: null,
        });
      }
    } else if (
      this.props.selectdata.name === "room_eligible_ward" ||
      this.props.selectdata.name === "upgrade_room"
    ) {
      let type_of_package = null;
      type_of_package = localStorage.getItem("type_of_package");

      this.state.select2options.map((data, key) => {
        if (data.id === value) {
          this.props.onselectChanges({
            id: this.props.selectdata.name,
            name: this.props.selectdata.name,
            value: value,
            parrentMode: this.props.selectdata.parrentMode,
            parrentName: this.props.selectdata.parrentName,
            amount: data.amount,
            room_charges: data.room_charges,
            package_id: data.package_id ? data.package_id : null,
            text: text,
          });
        }
      });
    } else if (this.props.selectdata.name === "package_name") {
      this.state.select2options.map((data, key) => {
        if (data.id === value) {
          this.props.onselectChanges({
            id: this.props.selectdata.name,
            name: this.props.selectdata.name,
            value: value,
            parrentMode: this.props.selectdata.parrentMode,
            parrentName: this.props.selectdata.parrentName,
            length_of_stay: data.length_of_stay,
            text: text,
          });
        }
      });
    } else if (this.props.selectdata.name === "patient_list") {
      this.state.select2options.map((data, key) => {
        if (data.id === value) {
          this.props.onselectChanges({
            id: this.props.selectdata.name,
            name: this.props.selectdata.name,
            value: value,
            parrentMode: this.props.selectdata.parrentMode,
            parrentName: this.props.selectdata.parrentName,
            serviceTime: data.service_time,
            text: text,
          });
        }
      });
    } else if (this.props.selectdata.name === "doctorid") {
      this.state.select2options.map((data, key) => {
        if (data.id === value) {
          this.props.onselectChanges({
            id: this.props.selectdata.name,
            name: this.props.selectdata.name,
            value: value,
            parrentMode: this.props.selectdata.parrentMode,
            parrentName: this.props.selectdata.parrentName,
            speciality: data.speciality,
            speciality_id: data.speciality,
            text: text,
          });
        }
      });
    } else {
      this.props.onselectChanges({
        id: this.props.selectdata.name,
        text: text,
        name: this.props.selectdata.name,
        value: value,
        parrentMode: this.props.selectdata.parrentMode,
        parrentName: this.props.selectdata.parrentName,
      });
    }
  }

  onBlur() {
    console.log("blur");
 
    // this.selectFetchCall(); this.selectFetchCall();
  }

  onFocus() {
    // console.log("focus");
  
    this.setState({ select2options: [], loading: true });
    //console.log(this.props);
    this.selectFetchCall();
  }

  onSearch(val) {
    if (this.props.selectdata.name === "secretary_doctor_id") {
      let payload = {
        data_count: 0,
        search_key: val,
      };

      postService("doctorsForSecretaries", "POST", payload).then((res) => {
        if (res) {
          res.data.map((data, key) => {
            res["data"][key]["name"] = data.name;
          });
          this.setState((state) => ({
            select2options: res.data,
            loading: false,
            fetching: false,
          }));
        } else {
          this.setState({ fetching: false });
        }
      });
    }
  }

  selectFetchCall() {
    this.setState({ fetching: true });
    const {
      master_unit,
      getAppointmentDoctorsById,
      master_serviceGroup,
      master_department,
      master_queueOperators,
      master_queueTechnicians,
      master_doctor,
      getRolesList,
      getPatientTypes,
      getDoctorSpecialities,
      getDoctorsforDropdown,
      getUsersDropdown,
      getProcedures,
      getCashNonPackageRoomsByUnitId,
      getAllInsuranceCompanies,
      getAllTpas,
      getPreExistingConditions,
      getRoomUpgradeReasons,
      getCounsellingType,
      getMasterAilmentCappingStatusOptions,
      getMasterPatientTypes,
      getMasterInsuranceTypes,
      getMasterSumInsuredFourYearsBackOptions,
      getMasterInsuranceStatus,
      getBreaktimeReasons,
      getMasterPreAuthStatus,
      getMasterCareManagement,
      getMasterEstimateTypes,
      getCounsellingSkipReasons,
      getPackagesForDropDown,
      getPackagesPricesById,
      getNonPackagePrices,
      blocksDropdown,
      floorsDropdownByblock,
      doctorsSearchdropdown,
      getAccessLevels,
      getServicesList,
      getWorkStationsForDoctorORBillers,
      getWorkStationsByUnit
    } = networkList;

    if (
      this.props.selectdata.name === "unit" ||
      this.props.selectdata.name === "unit_id"
    ) {
      postService(master_unit, "GET", "null").then((res) => {
     
        if (res) {
          this.setState((state) => ({
            select2options: res.data,
            loading: false,
            fetching: false,
          }));
        } else {
          this.setState({ fetching: false });
        }
      });
    }
    const qCreateTypeOptions = [
      // {
      //   id: "billing",
      //   name: "Billing",
      //   text: "Billing",
      // },
      {
        id: "opdconsultation",
        name: "OPD Consultation",
        text: "OPD Consultation",
      },
      // {
      //   id: "radiology",
      //   name: "Radiology",
      //   text: "Radiology",
      // },
    ];
    if (
      this.props.selectdata.name === "qCreateType" ||
      this.props.selectdata.name === "qType_id"
    ) {
      this.setState((state) => ({
        select2options: qCreateTypeOptions,
        loading: false,
        fetching: false,
      }));
    }

    if (this.props.selectdata.name === "queuedepartment") {
      let { add_queue_payload } = this.props;
   
      postService("getQueueDepartments", "POST", {
        unitid: add_queue_payload["unit_id"]
          ? add_queue_payload["unit_id"]
          : null,
      }).then((res) => {
        if (res) {
          this.setState((state) => ({
            select2options: res.data,
            loading: false,
            fetching: false,
          }));
        } else {
          this.setState({ fetching: false });
        }
      });
    }

    if (
      this.props.selectdata.name === "service" ||
      this.props.selectdata.name === "service_group"
    ) {
      let unitid = this.props.addQueue.map(data => data.name === "unit" ? data.value : null)
     postService(master_serviceGroup, "POST", {
        // departmentID: this.getQueuevalue("department") ? this.getQueuevalue("department") : this.getQueuevalue("department_id") ? this.getQueuevalue("department_id") : this.getQueuevalue("queuedepartment"),
        unitID : unitid[0]
      }).then((res) => {
        if (res) {
          this.setState((state) => ({
            select2options: res.data,
            loading: false,
            fetching: false,
          }));
        } else {
          this.setState({ fetching: false });
        }
      });
    }

    if (this.props.selectdata.name === "alloperator") {
      let { add_queue_payload } = this.props;

      postService(master_queueOperators, "POST", {
        unitid: add_queue_payload["unit_id"]
          ? add_queue_payload["unit_id"]
          : null,
      }).then((res) => {
      
        if (res) {
          this.setState((state) => ({
            select2options: res.data,
            loading: false,
            fetching: false,
          }));
        } else {
          this.setState({ fetching: false });
        }
      });
    }

    if (this.props.selectdata.name === "technician") {
      let { add_queue_payload } = this.props;

      postService(master_queueTechnicians, "POST", {
        unitid: add_queue_payload["unit_id"]
          ? add_queue_payload["unit_id"]
          : null,
      }).then((res) => {
    

        if (res) {
          this.setState((state) => ({
            select2options: res.data,
            loading: false,
            fetching: false,
          }));
        } else {
          this.setState({ fetching: false });
        }
      });
    }

    // const ws = [
    //   {
    //     id: "workstation1",
    //     name: "Work station1",
    //     text: "Work station1",
    //   },
    //   {
    //     id: "workstation2",
    //     name: "Work station2",
    //     text: "Work station2",
    //   },
    //   {
    //     id: "workstation3",
    //     name: "Work station3",
    //     text: "Work station3",
    //   },
    // ];
    if (this.props.selectdata.name === "workstation") {
      postService(getWorkStationsForDoctorORBillers, "GET", null).then(
        (res) => {
          if (res.status) {
            let newData = [];
            if (res.data.length !== 0) {
              res.data.map((roomData, roomKey) => {
                newData.push({
                  id: roomData["id"],
                  name: roomData["work_station_name"],
                });
              });
            }
            this.setState((state) => ({
              select2options: newData,
              loading: false,
              fetching: false,
            }));
          } else {
            this.setState({ fetching: false });
          }
        }
      );
    }
    if (this.props.selectdata.name === "accessLevel") {
      postService(getAccessLevels, "GET", null).then((res) => {
        if (res) {
          this.setState((state) => ({
            select2options: res.data,
            loading: false,
            fetching: false,
          }));
        } else {
          this.setState({ fetching: false });
        }
      });
    }

    if (this.props.selectdata.name === "service_group_id") {
      postService(getServicesList, "GET", null).then((res) => {
        if (res) {
          this.setState((state) => ({
            select2options: res.data,
            loading: false,
            fetching: false,
          }));
        } else {
          this.setState({ fetching: false });
        }
      });
    }

    if (this.props.selectdata.name === "block_id") {
      postService("blocksList", "GET", "null").then((res) => {
        if (res) {
          res.data.map((data, key) => {
            res["data"][key]["name"] = data.block_name;
          });
          this.setState((state) => ({
            select2options: res.data,
            loading: false,
            fetching: false,
          }));
        } else {
          this.setState({ fetching: false });
        }
      });
    }

    if (this.props.selectdata.name === "floor_id") {
      postService("floorsList", "GET", "null").then((res) => {
        if (res) {
          res.data.map((data, key) => {
            res["data"][key]["name"] = data.floor_name;
          });
          this.setState((state) => ({
            select2options: res.data,
            loading: false,
            fetching: false,
          }));
        } else {
          this.setState({ fetching: false });
        }
      });
    }

    if (this.props.selectdata.name === "ot_id") {
      postService("floorsList", "GET", "null").then((res) => {
        if (res) {
          res.data.map((data, key) => {
            res["data"][key]["name"] = data.floor_name;
          });
          this.setState((state) => ({
            select2options: res.data,
            loading: false,
            fetching: false,
          }));
        } else {
          this.setState({ fetching: false });
        }
      });
    }

    if (this.props.selectdata.name === "secretary_doctor_id") {
      let payload = {
        data_count: 0,
        search_key: "",
      };

      postService("doctorsForSecretaries", "POST", payload).then((res) => {
        if (res) {
          res.data.map((data, key) => {
            res["data"][key]["name"] = data.name;
          });
          this.setState((state) => ({
            select2options: res.data,
            loading: false,
            fetching: false,
          }));
        } else {
          this.setState({ fetching: false });
        }
      });
    }

    if (this.props.selectdata.name === "counsellor_id") {
      postService(getUsersDropdown, "GET", "null").then((res) => {
        if (res) {
          let newData = [];
          res.data.map((userData, roomKey) => {
            newData.push({
              id: userData["id"],
              name: userData["username"],
            });
          });
          this.setState((state) => ({
            select2options: newData,
            loading: false,
            fetching: false,
          }));
        } else {
          this.setState({ fetching: false });
        }
      });
    }

    if (this.props.selectdata.name === "patient_type_blocked") {
      postService(getPatientTypes, "GET", "null").then((res) => {
        if (res) {
          this.setState((state) => ({
            select2options: res.data,
            loading: false,
            fetching: false,
          }));
        } else {
          this.setState({ fetching: false });
        }
      });
    }

    if (this.props.selectdata.name === "insurance_company") {
      postService(getAllInsuranceCompanies, "GET", "null").then((res) => {
        if (res) {
          this.setState((state) => ({
            select2options: res.data,
            loading: false,
            fetching: false,
          }));
        } else {
          this.setState({ fetching: false });
        }
      });
    }

    if (this.props.selectdata.name === "tpa_name") {
      postService(getAllTpas, "GET", "null").then((res) => {
        if (res) {
          this.setState((state) => ({
            select2options: res.data,
            loading: false,
            fetching: false,
          }));
        } else {
          this.setState({ fetching: false });
        }
      });
    }

    if (this.props.selectdata.name === "condition_name") {
      postService(getPreExistingConditions, "GET", "null").then((res) => {
        if (res) {
          let newData = [];
          if (res.data.length !== 0) {
            res.data.map((roomData, roomKey) => {
              newData.push({
                id: roomData["id"],
                name: roomData["value"],
              });
            });
          }
          this.setState((state) => ({
            select2options: newData,
            loading: false,
            fetching: false,
          }));
        } else {
          this.setState({ fetching: false });
        }
      });
    }

    if (
      this.props.selectdata.name === "department" ||
      this.props.selectdata.name === "department_id"
    ) {
      postService(master_department, "POST", {
        unitID: this.getQueuevalue("unit")
          ? this.getQueuevalue("unit")
          : this.getQueuevalue("unit_id"),
      }).then((res) => {
      
        if (res) {
          this.setState((state) => ({
            select2options: res.data,
            loading: false,
            fetching: false,
          }));
        } else {
          this.setState({ fetching: false });
        }
      });
    }

    if (this.props.selectdata.name === "doctorid") {
      postService(getDoctorsforDropdown, "GET", "null").then((res) => {
        if (res) {
          this.setState((state) => ({
            select2options: res.data,
            loading: false,
            fetching: false,
          }));
        } else {
          this.setState({ fetching: false });
        }
      });
    }

    if (
      this.props.selectdata.name === "surgery_procedure_name" ||
      this.props.selectdata.name === "additional_procedure" ||
      this.props.selectdata.name === "surgery" ||
      this.props.selectdata.name === "additional_procdure_id"
    ) {
      postService(getProcedures, "GET", "null").then((res) => {
        if (res) {
          this.setState((state) => ({
            select2options: res.data,
            loading: false,
            fetching: false,
          }));
        } else {
          this.setState({ fetching: false });
        }
      });
    }

    if (this.props.selectdata.name === "counselling_type") {
      postService(getCounsellingType, "GET", "null").then((res) => {
        if (res) {
          let newData = [];
          if (res.data.length !== 0) {
            res.data.map((roomData, roomKey) => {
              newData.push({
                id: roomData["id"],
                name: roomData["value"],
              });
            });
          }
          this.setState((state) => ({
            select2options: newData,
            loading: false,
            fetching: false,
          }));
        } else {
          this.setState({ fetching: false });
        }
      });
    }

    if (this.props.selectdata.name === "doctor") {
      let { id, slug } = this.props.match.params;

      if (id === "appointments") {
        postService(getAppointmentDoctorsById, "POST", {
          data: {
            unit: this.getQueuevalue("unit")
              ? this.getQueuevalue("unit")
              : this.getQueuevalue("unit_id"),
            department: this.getQueuevalue("department")
              ? this.getQueuevalue("department")
              : this.getQueuevalue("department_id"),
            service_group: this.getQueuevalue("service_group")
              ? this.getQueuevalue("service_group")
              : this.getQueuevalue("service_group_id"),
          },
        }).then((res) => {
          if (res) {
            this.setState((state) => ({
              select2options: res.data,
              loading: false,
              fetching: false,
            }));
          } else {
            this.setState({ fetching: false });
          }
        });
      } else if (id === "generate-token") {
        postService(getDoctorsforDropdown, "GET", "null").then((res) => {
          if (res) {
            this.setState((state) => ({
              select2options: res.data,
              loading: false,
              fetching: false,
            }));
          } else {
            this.setState({ fetching: false });
          }
        });
      } else {
        postService(master_doctor, "POST", {
          departmentID: this.getQueuevalue("department")
            ? this.getQueuevalue("department")
            : this.getQueuevalue("department_id"),
        }).then((res) => {
          if (res) {
            this.setState((state) => ({
              select2options: res.data,
              loading: false,
              fetching: false,
            }));
          } else {
            this.setState({ fetching: false });
          }
        });
      }
    }

    if (
      this.props.selectdata.name === "role_id" ||
      this.props.selectdata.name === "role"
    ) {
   
      postService(getRolesList, "GET", null).then((res) => {
        if (res) {
          this.setState((state) => ({
            select2options: res.data,
            loading: false,
            fetching: false,
          }));
        } else {
          this.setState({ fetching: false });
        }
      });
    }
    // //service groups
    if(this.props.selectdata.name === "group"){
      postService(getServicesList, "GET", null).then((res)=>{
      
        if(res){
       
          this.setState((state) => ({
            select2options: res.data,
            loading: false,
            fetching: false,
          }));
        }
        else {
     
          this.setState({ fetching: false });
        }
      })
    }
    if (this.props.selectdata.name === "speciality_id") {
      postService(getDoctorSpecialities, "GET", null).then((res) => {
        if (res) {
          this.setState((state) => ({
            select2options: res.data,
            loading: false,
            fetching: false,
          }));
        } else {
          this.setState({ fetching: false });
        }
      });
    }

    if (this.props.selectdata.name === "payment") {
      var data = [
        {
          id: 1,
          name: "Cash",
        },
        {
          id: 2,
          name: "Insurance",
        },
        {
          id: 3,
          name: "Corporate",
        },
      ];
      this.setState((state) => ({
        select2options: data,
        loading: false,
        fetching: false,
      }));
    }
    if (this.props.selectdata.name === "select_difference") {
      var data = [
        {
          id: "room_differance",
          name: "Room Difference Amount",
        },
        {
          id: "pro_rata_differance",
          name: "Pro Rata Difference Amount",
        },
      ];
      this.setState((state) => ({
        select2options: data,
        loading: false,
        fetching: false,
      }));
    }

    if (this.props.selectdata.name === "type_of_management") {
      postService(getMasterCareManagement, "GET", "null").then((res) => {
        if (res) {
          let newData = [];
          if (res.data.length !== 0) {
            res.data.map((roomData, roomKey) => {
              newData.push({
                id: roomData["id"],
                name: roomData["value"],
              });
            });
          }
          this.setState((state) => ({
            select2options: newData,
            loading: false,
            fetching: false,
          }));
        } else {
          this.setState({ fetching: false });
        }
      });
    }

    if (this.props.selectdata.name === "sum_insured_four_years_back") {
      postService(getMasterSumInsuredFourYearsBackOptions, "GET", "null").then(
        (res) => {
          if (res) {
            let newData = [];
            if (res.data.length !== 0) {
              res.data.map((roomData, roomKey) => {
                newData.push({
                  id: roomData["id"],
                  name: roomData["value"],
                });
              });
            }
            this.setState((state) => ({
              select2options: newData,
              loading: false,
              fetching: false,
            }));
          } else {
            this.setState({ fetching: false });
          }
        }
      );
    }

    if (this.props.selectdata.name === "type_of_package") {
      postService(getMasterEstimateTypes, "GET", "null").then((res) => {
        if (res) {
          let newData = [];
          if (res.data.length !== 0) {
            res.data.map((roomData, roomKey) => {
              newData.push({
                id: roomData["id"],
                name: roomData["value"],
              });
            });
          }
          this.setState((state) => ({
            select2options: newData,
            loading: false,
            fetching: false,
          }));
        } else {
          this.setState({ fetching: false });
        }
      });
    }

    //         Room upgrade Reason
    // Non availability
    // Complimentary
    // Upgrade Excess Charge Payable

    if (this.props.selectdata.name === "ailment_capping_status") {
      postService(getMasterAilmentCappingStatusOptions, "GET", "null").then(
        (res) => {
          if (res) {
            let newData = [];
            if (res.data.length !== 0) {
              res.data.map((roomData, roomKey) => {
                newData.push({
                  id: roomData["id"],
                  name: roomData["value"],
                });
              });
            }
            this.setState((state) => ({
              select2options: newData,
              loading: false,
              fetching: false,
            }));
          } else {
            this.setState({ fetching: false });
          }
        }
      );
      // var data = [
      //     {
      //         'id': 1,
      //         'name': 'Yes'
      //     }, {
      //         'id': 2,
      //         'name': 'No'
      //     }]
      // this.setState((state) => ({ select2options: data, loading: false, fetching: false }));
    }

    // if (this.props.selectdata.name === 'room_upgrade_reason') {
    //     postService(getRoomUpgradeReasons, 'GET', 'null').then(res => {
    //         if (res) {
    //             let newData = [];
    //             if (res.data.length !== 0) {
    //                 res.data.map((roomData, roomKey) => {
    //                     newData.push({
    //                         'id': roomData['id'],
    //                         'name': roomData['value']
    //                     })

    //                 })
    //             }
    //             this.setState((state) => ({ select2options: newData, loading: false, fetching: false }));
    //         } else {
    //             this.setState({ fetching: false });
    //         }
    //     });

    // }

    if (this.props.selectdata.name === "type_of_insurance") {
      postService(getMasterInsuranceTypes, "GET", "null").then((res) => {
        if (res) {
          let newData = [];
          if (res.data.length !== 0) {
            res.data.map((roomData, roomKey) => {
              newData.push({
                id: roomData["id"],
                name: roomData["value"],
              });
            });
          }
          this.setState((state) => ({
            select2options: newData,
            loading: false,
            fetching: false,
          }));
        } else {
          this.setState({ fetching: false });
        }
      });
    }

    if (this.props.selectdata.name === "insurance_status") {
      postService(getMasterInsuranceStatus, "GET", "null").then((res) => {
        if (res) {
          let newData = [];
          if (res.data.length !== 0) {
            res.data.map((roomData, roomKey) => {
              newData.push({
                id: roomData["id"],
                name: roomData["value"],
              });
            });
          }
          this.setState((state) => ({
            select2options: newData,
            loading: false,
            fetching: false,
          }));
        } else {
          this.setState({ fetching: false });
        }
      });
    }

    if (this.props.selectdata.name === "pre_auth_status") {
      postService(getMasterPreAuthStatus, "GET", "null").then((res) => {
        if (res) {
          let newData = [];
          if (res.data.length !== 0) {
            res.data.map((roomData, roomKey) => {
              newData.push({
                id: roomData["id"],
                name: roomData["value"],
              });
            });
          }
          this.setState((state) => ({
            select2options: newData,
            loading: false,
            fetching: false,
          }));
        } else {
          this.setState({ fetching: false });
        }
      });
    }

    if (this.props.selectdata.name === "claim_type") {
      postService(getMasterInsuranceTypes, "GET", "null").then((res) => {
        if (res) {
          let newData = [];
          if (res.data.length !== 0) {
            res.data.map((roomData, roomKey) => {
              newData.push({
                id: roomData["id"],
                name: roomData["value"],
              });
            });
          }
          this.setState((state) => ({
            select2options: newData,
            loading: false,
            fetching: false,
          }));
        } else {
          this.setState({ fetching: false });
        }
      });
    }

    if (this.props.selectdata.name === "patient_type") {
      postService(getMasterPatientTypes, "GET", "null").then((res) => {
        if (res) {
          let newData = [];
          if ((res.data && Array, isArray(res.data) && res.data.length !== 0)) {
            res.data.map((roomData, roomKey) => {
              newData.push({
                id: roomData["id"],
                name: roomData["value"],
              });
            });
          }
          this.setState((state) => ({
            select2options: newData,
            loading: false,
            fetching: false,
          }));
        } else {
          this.setState({ fetching: false });
        }
      });
    }

    if (
      this.props.selectdata.name === "room_opted" ||
      this.props.selectdata.name === "room_upgrade"
    ) {
      let user_data = null;
      let package_data = null;
      let type_of_package = null;
      let payment_type = null;
      payment_type = localStorage.getItem("payment");
      if (localStorage.getItem("user_data") !== null) {
        user_data = JSON.parse(localStorage.getItem("user_data"));
        package_data = localStorage.getItem("package_name");
        type_of_package = localStorage.getItem("type_of_package");
        let payload = {};
        let url = null;
        let room_eligible_ward_cost = localStorage.getItem(
          "room_eligible_ward_cost"
        );

        if (type_of_package == 1) {
          url = getPackagesPricesById;
          payload = {
            package_id: package_data,
            unit_id: user_data["unitid"],
            payment_type: payment_type,
          };

          postService(url, "POST", {
            data: payload,
          }).then((res) => {
            if (res) {
              let newData = [];
              if (res.data.length !== 0) {
                res.data.map((roomData, roomKey) => {
                  if (type_of_package == 1) {
                    newData.push({
                      disabled:
                        this.props.selectdata.name === "room_upgrade"
                          ? room_eligible_ward_cost !== null &&
                            parseFloat(room_eligible_ward_cost) >=
                              parseFloat(roomData["value"])
                            ? true
                            : false
                          : false,
                      id: roomData["room_name"],
                      name:
                        roomData["room_name"].charAt(0).toUpperCase() +
                        roomData["room_name"].slice(1),
                      amount: roomData["value"],
                      package_id: roomData["id"],
                    });
                  }
                });
              }
              this.setState((state) => ({
                select2options: newData,
                loading: false,
                fetching: false,
              }));
            } else {
              this.setState({ select2options: [], fetching: false });
            }
          });
        } else {
          postService(getCashNonPackageRoomsByUnitId, "POST", {
            unit_id: user_data["unitid"],
          }).then((res) => {
            if (res) {
              let newData = [];
              if (res.data.length !== 0) {
                res.data.map((roomData, roomKey) => {
                  newData.push({
                    disabled:
                      this.props.selectdata.name === "room_upgrade"
                        ? room_eligible_ward_cost !== null &&
                          parseFloat(room_eligible_ward_cost) >=
                            parseFloat(roomData["amount"])
                          ? true
                          : false
                        : false,
                    id: roomData["id"],
                    name: roomData["room_name"],
                    amount: roomData["amount"],
                    package_id: roomData["id"],
                  });
                });
              }
              this.setState((state) => ({
                select2options: newData,
                loading: false,
                fetching: false,
              }));
            } else {
              this.setState({ select2options: [], fetching: false });
            }
          });
        }
      } else {
        this.setState({ fetching: false });
      }
    }

    if (
      this.props.selectdata.name === "room_eligible_ward" ||
      this.props.selectdata.name === "upgrade_room"
    ) {
      let package_data = null;
      let type_of_package = null;
      let payment_type = null;
      let insurance_company = null;
      let tpa = null;
      let user_data = null;
      let room_eligible_ward_cost = 0;
      room_eligible_ward_cost = localStorage.getItem("room_eligible_ward_cost");
      if (localStorage.getItem("package_name") !== null) {
        package_data = localStorage.getItem("package_name");
      }
      type_of_package = localStorage.getItem("type_of_package");

      payment_type = localStorage.getItem("payment");
      if (
        localStorage.getItem("insurance_company") !== null ||
        localStorage.getItem("tpa_name") !== null
      ) {
        insurance_company = localStorage.getItem("insurance_company");
        tpa = localStorage.getItem("tpa_name");
      }

      if (localStorage.getItem("user_data") !== null) {
        user_data = JSON.parse(localStorage.getItem("user_data"));
      }

      let payload = {};
      let url = null;
      if (type_of_package == 1) {
        url = getPackagesPricesById;
        payload = {
          unit_id: user_data["unitid"],
          package_id: package_data,
          payment_type: payment_type,
        };
      } else {
        url = getNonPackagePrices;
        payload = {
          unit_id: user_data["unitid"],
          payment_type: payment_type,
          insurance_company: insurance_company,
          tpa: tpa,
        };
      }

      postService(url, "POST", {
        data: payload,
      }).then((res) => {
        if (res) {
          let newData = [];
          if (res.data.length !== 0) {
            res.data.map((roomData, roomKey) => {
              if (type_of_package == 1) {
                newData.push({
                  disabled:
                    this.props.selectdata.name === "upgrade_room"
                      ? room_eligible_ward_cost !== null &&
                        parseFloat(room_eligible_ward_cost) >=
                          parseFloat(roomData["room_charges"])
                        ? true
                        : false
                      : false,
                  id: roomData["room_name"],
                  name:
                    roomData["room_name"].charAt(0).toUpperCase() +
                    roomData["room_name"].slice(1),
                  amount: roomData["value"],
                  room_charges: roomData["room_charges"],
                  package_id: roomData["id"],
                });
              } else {
                newData.push({
                  disabled:
                    this.props.selectdata.name === "upgrade_room"
                      ? room_eligible_ward_cost !== null &&
                        parseFloat(room_eligible_ward_cost) >=
                          parseFloat(roomData["value"])
                        ? true
                        : false
                      : false,
                  id: roomData["id"],
                  name: roomData["room_name"],
                  amount: roomData["value"],
                  room_charges: roomData["value"],
                  package_id: roomData["id"],
                });
              }
            });
          }
          this.setState((state) => ({
            select2options: newData,
            loading: false,
            fetching: false,
          }));
        } else {
          this.setState({ fetching: false });
        }
      });
    }

    if (this.props.selectdata.name === "package_name") {
      let user_data = null;
      let payment_type = null;
      let insurance_company = null;
      let tpa = null;
      if (
        localStorage.getItem("user_data") !== null &&
        localStorage.getItem("payment") !== null
      ) {
        user_data = JSON.parse(localStorage.getItem("user_data"));
        payment_type = localStorage.getItem("payment");
        if (
          localStorage.getItem("insurance_company") !== null ||
          localStorage.getItem("tpa_name") !== null
        ) {
          insurance_company = localStorage.getItem("insurance_company");
          tpa = localStorage.getItem("tpa_name");
        }
        let payload = {
          unit_id: user_data["unitid"],
          payment_type: payment_type,
          insurance_company: insurance_company,
          tpa: tpa,
        };
        // console.clear();
        // console.log(payload);
        postService(getPackagesForDropDown, "POST", {
          data: {
            unit_id: user_data["unitid"],
            payment_type: payment_type,
            insurance_company: insurance_company,
            tpa: tpa,
          },
        }).then((res) => {
          if (res) {
            let newData = [];
            if (res.data.length !== 0) {
              res.data.map((roomData, roomKey) => {
                newData.push({
                  id: roomData["id"],
                  name: roomData["value"],
                  length_of_stay: roomData["length_of_stay"],
                });
              });
            }
            this.setState((state) => ({
              select2options: newData,
              loading: false,
              fetching: false,
            }));
          } else {
            this.setState({ fetching: false });
          }
        });
      } else {
        this.setState({ fetching: false });
      }
    }

    if (this.props.selectdata.name === "break_reason_dropdown") {
      postService(getBreaktimeReasons, "GET", "null").then((res) => {
        // console.log(res);
        if (res) {
          let newData = [];
          if (res.data.length !== 0) {
            res.data.map((roomData, roomKey) => {
              newData.push({
                id: roomData["id"],
                name: roomData["reason"],
              });
            });
          }
          this.setState((state) => ({
            select2options: newData,
            loading: false,
            fetching: false,
          }));
        } else {
          this.setState({ fetching: false });
        }
      });
    }

    if (this.props.selectdata.name === "room_upgrade_reason") {
      let payment = localStorage.getItem("payment");
      if (payment === "Insurance") {
        payment = 2;
      } else {
        payment = 1;
      }

      postService(getRoomUpgradeReasons, "POST", {
        data: {
          payment_type: payment,
        },
      }).then((res) => {
        if (res) {
          let newData = [];
          if (res.data.length !== 0) {
            res.data.map((roomData, roomKey) => {
              newData.push({
                id: roomData["id"],
                name: roomData["value"],
              });
            });
          }
          this.setState((state) => ({
            select2options: newData,
            loading: false,
            fetching: false,
          }));
        } else {
          this.setState({ fetching: false });
        }
      });
    }

    if (this.props.selectdata.name === "reason_dropdown") {
      postService(getCounsellingSkipReasons, "GET", "null").then((res) => {
        console.log(res);
        if (res) {
          let newData = [];
          if (res.data.length !== 0) {
            res.data.map((roomData, roomKey) => {
              newData.push({
                id: roomData["id"],
                name: roomData["reason"],
              });
            });
          }
          this.setState((state) => ({
            select2options: newData,
            loading: false,
            fetching: false,
          }));
        } else {
          this.setState({ fetching: false });
        }
      });
    }

    if (this.props.selectdata.name === "days") {
      var data = [
        {
          id: 1,
          name: "Monday",
        },
        {
          id: 2,
          name: "Tuesday",
        },
        {
          id: 3,
          name: "Wednesday",
        },
        {
          id: 4,
          name: "Thursday",
        },
        {
          id: 5,
          name: "Friday",
        },
        {
          id: 6,
          name: "Saturday",
        },
        {
          id: 7,
          name: "Sunday",
        },
      ];
      this.setState((state) => ({
        select2options: data,
        loading: false,
        fetching: false,
      }));
    }

    if (this.props.selectdata.name === "gender") {
      var data = [
        {
          id: "male",
          name: "Male",
        },
        {
          id: "female",
          name: "Female",
        },
      ];
      this.setState((state) => ({
        select2options: data,
        loading: false,
        fetching: false,
      }));
    }

    if (this.props.selectdata.name === "emergency") {
      var data = [
        {
          id: "1",
          name: "Yes",
        },
        {
          id: "0",
          name: "No",
        },
      ];
      this.setState((state) => ({
        select2options: data,
        loading: false,
        fetching: false,
      }));
    }

    if (this.props.selectdata.name === "payment_type") {
      var data = [
        {
          id: "1",
          name: "Cash",
        },
        {
          id: "2",
          name: "Insurance",
        },
      ];
      this.setState((state) => ({
        select2options: data,
        loading: false,
        fetching: false,
      }));
    }

    if (this.props.selectdata.name === "patient_list") {
      // let patientidentity, patienttype;
      // if (this.getFormvalue('ipnumber')) {
      //     patientidentity = this.getFormvalue('ipnumber');
      //     patienttype = 'IP'
      // } else {
      //     patientidentity = this.getFormvalue('umr');
      //     patienttype = 'OP'
      // }

      // var obj = {
      //     "patientidentity": (patientidentity === null) ? '' : patientidentity,
      //     "mobileno": this.getFormvalue('mobile'),
      //     "patienttype": patienttype,
      // };
      // postService(getPatientDetailsForApptSlot, 'POST', { data: obj }).then(res => {
      let res = { data: this.props.searchPatient };

      if (res) {
        var data = [];
        if (res.data.length > 0) {
          for (var s = 0; s < res.data.length; s++) {
            let {
              PATIENTNAME,
              UMRNO,
              MOBILE_NUMBER,
              GENDER,
              AGE,
              ADMISSIONNO,
            } = res.data[s];

            let ind_data_txt =
              PATIENTNAME +
              "," +
              UMRNO +
              "," +
              MOBILE_NUMBER +
              "," +
              GENDER +
              "," +
              AGE;
            ind_data_txt = ind_data_txt.replace(/,+/g, ","); // replace double commas with single comma
            res.data[s]["name"] = ind_data_txt;

            let ind_data = {
              NAME: PATIENTNAME,
              UMR: UMRNO,
              MOBILENO: MOBILE_NUMBER,
              GENDER: GENDER,
              IP: ADMISSIONNO ? ADMISSIONNO : null,
              AGE: AGE,
              ID: s,
            };
            let ind_data_str = JSON.stringify(ind_data);
            res.data[s]["id"] = ind_data_str.slice(1, -1);

            data.push(res.data[s]);
          }
        }

        this.setState((state) => ({
          select2options: data,
          loading: false,
          fetching: false,
        }));
      } else {
        this.setState({ fetching: false });
      }
      // });
    }
    if (this.props.selectdata.name === "post_block_id") {
      let id = JSON.parse(Storage.get("tempunitid"));
      if (id !== null) {
        postService(blocksDropdown, "POST", { unit_id: id }).then((res) => {
          if (res) {
            let newData = [];
            if (res.data.length !== 0) {
              res.data.map((blockdata, blockKey) => {
                newData.push({
                  id: blockdata["block_id"],
                  name: blockdata["block_name"],
                });
              });
            }
            this.setState((state) => ({
              select2options: newData,
              loading: false,
              fetching: false,
            }));
          } else {
            this.setState({ fetching: false });
          }
        });
      }
    }
    if (this.props.selectdata.name === "floor") {
      let id = JSON.parse(Storage.get("tempblockid"));
      if (id !== null) {
        postService(floorsDropdownByblock, "POST", { block_id: id }).then(
          (res) => {
            if (res) {
              let newData = [];
              if (res.data.length !== 0) {
                res.data.map((floordata, blockKey) => {
                  newData.push({
                    id: floordata["floor_id"],
                    name: floordata["floor_name"],
                  });
                });
              }
              this.setState((state) => ({
                select2options: newData,
                loading: false,
                fetching: false,
              }));
            } else {
              this.setState({ fetching: false });
            }
          }
        );
      }
    }
    if (this.props.selectdata.name === "doctor_name") {
    
      let payload = {
        data_count: 0,
        search_key: "",
      };
      postService(doctorsSearchdropdown, "POST", payload).then((res) => {
        if (res) {
          this.setState((state) => ({
            select2options: res.data,
            loading: false,
            fetching: false,
          }));
        } else {
          this.setState({ fetching: false });
        }
      });
    }
    if (this.props.selectdata.name === "filters") {
      let data = [
        {
          id: 1,
          name: "Appointment",
        },
        {
          id: 2,
          name: "Walkins",
        },
      ];
      this.setState((state) => ({
        select2options: data,
        loading: false,
        fetching: false,
      }));
    }
    if (this.props.selectdata.name === "billingFilters") {
      let data = [
        {
          id: "newregistration",
          name: "New Registration",
        },
        {
          id: "billing",
          name: "Billing",
        },
      ];
      this.setState((state) => ({
        select2options: data,
        loading: false,
        fetching: false,
      }));
    }
    if (this.props.selectdata.name === "dashboardFilters") {
      let { formData } = this.props;
      let filterForReportType =
        formData &&
        (formData[3] && formData[3].value === "Billing"
          ? [
              {
                id: 2,
                name: "New Patients",
              },
              {
                id: 3,
                name: "Old Patients",
              },
            ]
          : [
              {
                id: 2,
                name: "Planned Visits",
              },
              {
                id: 3,
                name: "Un-Planned Visits",
              },
            ]);
      let data = [
        {
          id: 1,
          name: "Total Patients",
        },
        ...filterForReportType,
        {
          id: 4,
          name: "Serviced",
        },
        {
          id: 5,
          name: "Waiting",
        },
        {
          id: 6,
          name: "No-Shows",
        },
        {
          id: 7,
          name: "Total Skips",
        },
      ];
      this.setState((state) => ({
        select2options: data,
        loading: false,
        fetching: false,
      }));
    }
    if (this.props.selectdata.name === "work_station") {
      // let unitid = localStorage.getItem("workstationbyunitid");
      let unitid = this.props.Queuedata.filter(feild => feild.name === "unit")
      let payload={ "unitid": unitid[0] && unitid[0].value }
      postService(getWorkStationsByUnit, "POST",{data:payload} ).then(
        (res) => {
          if (res.status) {
            let newData = [];
            if (res.data.length !== 0) {
              res.data.map((roomData, roomKey) => {
                newData.push({
                  id: roomData["work_station_code"],
                  name: roomData["work_station_name"],
                });
              });
            }
            this.setState((state) => ({
              select2options: newData,
              loading: false,
              fetching: false,
            }));
          } else {
            this.setState({ fetching: false });
          }
        }
      );
    }
  }

  getQueuevalue(name) {
    let { Queuedata } = this.props;
  
    let value = null;
    Queuedata.map(
      (data) => data["name"] === name && (value = data["value"])
      // {
      //   if (data["name"] === name && data["valid"]) {
      //     value = data["value"];
      //   }
      // }
    );
    return value;
  }
  getFormvalue(name) {
    let { formData } = this.props;
    let value = null;
    formData.filter((data) => {
      if (data["name"] === name && data["valid"]) {
        value = data["value"];
      }
    });
    return value;
  }

  render() {
    const { fetching } = this.state;
    let defaultallowClear = false;
    let allowClear = false;
    let mode = "single";
    let defvalue = null;
    let valueText = this.state.selectdata.text
      ? this.state.selectdata.text
      : null;
    const Option = Select.Option;
    const children = [];
    if (this.state.select2options.length !== 0) {
      this.state.select2options.map((data, key) => {
        if (data.id !== null) {
          children.push(
            <Option
              key={key}
              value={data.id}
              disabled={data.disabled ? data.disabled : false}
            >
              {data.name ? data.name : data.value}
            </Option>
          );
        }
      });
    }
    if (this.props.selectdata.name === "additional_procedure") {
      mode = "multiple";
      defvalue = [];
      valueText = [];
    }
    if (this.props.selectdata.name === "room_upgrade") {
      defaultallowClear = true;
    }
    // console.log(this.state.selectdata);
    return (
      <Select
        showSearch
        mode={mode}
        style={{
          width: "100%",
          height: "30px",
        }}
        placeholder={this.state.selectdata.placeholder}
        // defaultValue={defvalue}
        allowClear={defaultallowClear}
        value={
          (this.props.editModalData && this.props.editModalData.unitname) ||
          (this.state.selectdata.text && this.state.selectdata.text)
        }
        optionFilterProp="children"
        onChange={this.onChange.bind(this)}
        onFocus={this.onFocus.bind(this)}
        onBlur={this.onBlur.bind(this)}
        notFoundContent={
          fetching ? (
            <Spin size="small" />
          ) : (
            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
          )
        }
        onSearch={this.onSearch.bind(this)}
        disabled={this.state.selectdata.disable}
        loading={false}
        menuItemSelectedIcon={
          // <Icon type="user" style={{ color: "rgba(0,0,0,.25)" }} />
          <UserOutlined style={{ color: 'rgba(0,0,0,.25)' }} />
        }
        dropdownMatchSelectWidth={false}
      >
        {children}
      </Select>
    );
  }
}

export default Select2;
